import { render, staticRenderFns } from "./Dialog_CreateClassPackage.vue?vue&type=template&id=afc673c8&scoped=true&"
import script from "./Dialog_CreateClassPackage.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateClassPackage.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateClassPackage.vue?vue&type=style&index=0&id=afc673c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc673c8",
  null
  
)

export default component.exports